import axios from 'axios';
import store from '../index';
import router from '@/router';

const state = {
	autenticate: 0,
	name: '',
	email: '',
	token: localStorage.getItem('token') || '',
	refresh: localStorage.getItem('refresh') || '',
	expired: localStorage.getItem('expired') || '',
	id: '',
	profile: '',
	language: 'it',
	role: -1,
	permissions: [],
	modules: [],
	csrf: '',
	rollback: (localStorage.getItem('rollback') !== '') ? JSON.parse(localStorage.getItem('rollback')) : '',
	licenseExpired: false
};

const getters = {
	getName: state => {
		return state.name;
	},
	getLanguage: state => {
		return state.language;
	},
	getEmail: state => {
		return state.email;
	},

	getAutenticate: state => {
		return state.autenticate;
	},
	getToken: state => {
		return state.token;
	},
	getId: state => {
		return state.id;
	},
	getProfile: state => {
		return state.profile;
	},

	getRefresh: state => {
		return state.refresh;
	},
	getExpired: state => {
		return state.expired;
	},
	getRole: state => {
		return state.role;
	},
	getPermissions: state => {
		return state.permissions;
	},
	getModules: state => {
		return state.modules;
	},
	getCsrf: state => {
		return state.csrf;
	},
	getRollback: state => {
		return state.rollback
	},
	// amministratore: entrato con il suo account (role 0) o in un merchant con "Loggati come"
	// (c'e' la sessione per "Ritorna ad ..."). Serve alle voci del BO riservate allo staff
	isAdminSession: state => {
		return state.role === 0 || !!(state.rollback && state.rollback.email);
	},
	getLicenseExpired: state => {
		return state.licenseExpired
	}
};

/** Salva la sessione di un login riuscito (diretto o dopo il secondo fattore). */
const commitLogin = (context, data) => {
	context.commit('setEmail', data.email);
	context.commit('setName', data.name);
	context.commit('setAutenticate', 1);
	context.commit('setToken', data.accessToken);
	context.commit('setRefresh', data.refreshToken);
	context.commit('setId', data.id);
	context.commit('setProfile', data.profile);
	context.commit('setExpired', data.expired);
	context.commit('setRole', data.role);
	localStorage.setItem('token', data.accessToken);
	localStorage.setItem('refresh', data.refreshToken);
	localStorage.setItem('expired', data.expired);
	// un login nuovo non eredita mai il "Ritorna ad ..." di una sessione precedente
	clearRollback(context);
	// eventi socket (nuovi ordini...) del profilo appena entrato
	context.dispatch('socket/socket_login', null, { root: true });
};

/** Svuota la sessione admin salvata da "Loggati come". */
const clearRollback = context => {
	localStorage.setItem('rollback', '');
	context.commit('setRollback', '');
};

/** Chiamate autenticate della 2FA dal Profilo: `{ success, data, message }`, senza eccezioni. */
const twoFactorCall = (context, method, url, payload) => {
	const config = {
		headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
		'Content-Type': 'application/json',
	};
	const full = `${context.rootGetters['settings/getUrl']}${url}`;
	const request = method === 'get' ? axios.get(full, config) : axios.post(full, payload || {}, config);
	return request
		.then(response => ({ success: true, data: response.data }))
		.catch(error => ({ success: false, message: error.response && error.response.data && error.response.data.message }));
};

const actions = {
	logout: async context => {
		context.commit('setEmail', '');
		context.commit('setName', '');
		context.commit('setAutenticate', 0);
		context.commit('setToken', '');
		context.commit('setProfile', '');
		context.commit('setRefresh', '');
		context.commit('setId', '');
		context.commit('setExpired', '');
		context.commit('setRole', -1);
		//context.commit('setLanguage', '');
		localStorage.removeItem('token');
		localStorage.removeItem('refresh');
		localStorage.removeItem('expired');
		clearRollback(context);

		context.dispatch('socket/disconnect', null, { root: true });
		context.commit('settings/setPreload', false, { root: true });

		//store.co['settings/getUrl']
	},
	csrf: (context, payload) => {
		let url = 'csrf';

		//console.log(`${store.getters["settings/getUrl"]}${url}`);

		return axios
			.get(`${store.getters['settings/getUrl']}${url}`)
			.then(response => {
				context.commit('setCsrf', response.data.csrfToken);
				return true;
			})
			.catch(err => {
				return { status: false };
			});
	},
	refreshToken: (context, payload) => {
		let url = 'auth/token';
		var payload = { token: localStorage.getItem('refresh') }; //store.getters["profile/getRefresh"]
		//console.log(`${store.getters["settings/getUrl"]}${url}`);

		return axios
			.post(`${store.getters['settings/getUrl']}${url}`, payload)
			.then(success => {
				// console.log(success)
				if (success.status === 201) {
					context.commit('setEmail', success.data.email);
					context.commit('setName', success.data.name);
					context.commit('setAutenticate', 1);
					context.commit('setToken', success.data.accessToken);
					context.commit('setId', success.data.profile);
					context.commit('setExpired', success.data.expired);
					context.commit('setRole', success.data.role);
					context.commit('setProfile', success.data.profile);
					localStorage.setItem('token', success.data.accessToken);

					localStorage.setItem('expired', success.data.expired);
				}
				return success.data;
			})
			.then(data => {
				return { status: true, token: data.accessToken };
			})
			.catch(err => {
				console.log(err);
				return { status: false };
			});
	},
	/**
	 * "Loggati come" dalla lista utenti: chiama sempre il backend. Solo a login
	 * riuscito la sessione attuale viene salvata come rollback per "Ritorna ad ...".
	 */
	loginAs: async (context, payload) => {
		// se si impersona gia' qualcuno, il ritorno deve portare alla sessione admin originale
		const precedente =
			state.rollback && state.rollback.email
				? state.rollback
				: { email: state.email, name: state.name, token: state.token, refresh: state.refresh, expired: state.expired };

		let url = 'auth/login-as';
		return axios
			.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(success => {
				if (success.status === 201) {
					context.commit('setEmail', success.data.email);
					context.commit('setName', success.data.name);
					context.commit('setAutenticate', 1);
					context.commit('setToken', success.data.accessToken);
					context.commit('setRefresh', success.data.refreshToken);
					context.commit('setId', success.data.id);
					context.commit('setProfile', success.data.profile);
					context.commit('setExpired', success.data.expired);
					context.commit('setRole', success.data.role);
					localStorage.setItem('token', success.data.accessToken);
					localStorage.setItem('refresh', success.data.refreshToken);
					localStorage.setItem('expired', success.data.expired);
					localStorage.setItem('rollback', JSON.stringify(precedente));
					context.commit('setRollback', precedente);
					// il socket passa alla stanza dell'account impersonato ed esce da quella precedente
					context.dispatch('socket/socket_login', null, { root: true });
				}
				return success;
			})
			.catch(error => {
				return error.response;
			});
	},
	/** "Ritorna ad ..." del menu: ripristina la sessione admin salvata da loginAs. */
	rollbackLogin: async context => {
		if (!state.rollback || !state.rollback.email) {
			return { status: 404 };
		}
		localStorage.setItem('token', state.rollback.token);
		localStorage.setItem('refresh', state.rollback.refresh);
		localStorage.setItem('expired', state.rollback.expired);
		clearRollback(context);
		// di nuovo nella stanza del proprio profilo
		context.dispatch('socket/socket_login', null, { root: true });
		return { status: 201 };
	},
	asyncFetchData: async (context, payload) => {
		//_.assignIn(payload, { _csrf: context.rootGetters['profile/getCsrf'] });

		let url = 'auth/login';

		return axios
			.post(`${context.rootGetters['settings/getUrl']}${url}`, payload)
			.then(success => {
				// con la 2FA attiva la risposta e' solo una sfida: la sessione si salva dopo il codice
				if (success.status === 201 && !success.data.twoFactorRequired) {
					commitLogin(context, success.data);
				}
				return success;
			})
			.catch(error => {
				return error.response;
			});
	},
	// secondo passaggio del login: { challengeToken, code }
	loginTwoFactor: async (context, payload) => {
		return axios
			.post(`${context.rootGetters['settings/getUrl']}auth/login/2fa`, payload)
			.then(success => {
				if (success.status === 201) {
					commitLogin(context, success.data);
				}
				return success;
			})
			.catch(error => {
				return error.response;
			});
	},
	// recupero password (pubblico): 1001 email non presente, 1005 utente non attivo
	forgotPassword: async (context, email) => {
		return axios
			.post(`${context.rootGetters['settings/getUrl']}auth/forgot-password`, { email })
			.then(() => ({ success: true }))
			.catch(error => ({ success: false, message: error.response && error.response.data && error.response.data.message }));
	},
	// nuova password dal link di recupero: { token, password }
	resetPassword: async (context, payload) => {
		return axios
			.post(`${context.rootGetters['settings/getUrl']}auth/reset-password`, payload)
			.then(() => ({ success: true }))
			.catch(error => ({ success: false, message: error.response && error.response.data && error.response.data.message }));
	},
	resendTwoFactorCode: async (context, payload) => {
		return axios
			.post(`${context.rootGetters['settings/getUrl']}auth/login/2fa/resend`, payload)
			.then(() => ({ success: true }))
			.catch(error => ({ success: false, message: error.response && error.response.data && error.response.data.message }));
	},
	twoFactorStatus: context => twoFactorCall(context, 'get', 'auth/2fa'),
	twoFactorSetup: (context, method) => twoFactorCall(context, 'post', 'auth/2fa/setup', { method }),
	twoFactorEnable: async (context, code) => {
		const result = await twoFactorCall(context, 'post', 'auth/2fa/enable', { code });
		// attivazione: il backend chiude le altre sessioni e rimanda token nuovi per questa
		if (result.success) {
			await context.dispatch('applySession', result.data);
		}
		return result;
	},
	twoFactorDisable: (context, payload) => twoFactorCall(context, 'post', 'auth/2fa/disable', payload),
	twoFactorBackupCodes: (context, payload) => twoFactorCall(context, 'post', 'auth/2fa/backup-codes', payload),
	twoFactorSendCode: context => twoFactorCall(context, 'post', 'auth/2fa/send-code'),
	getProfile: async (context, payload) => {
		if (_.size(context.rootGetters['settings/getSetting']) > 0) {
			return context.rootGetters['settings/getSetting'];
		} else {
			let url = 'profile/setting';
			//console.log(`${context.rootGetters['settings/getUrl']}${url}`)
			return axios
				.get(
					`${context.rootGetters['settings/getUrl']}${url}`,

					{
						headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
						'Content-Type': 'application/json',
					},
				)
				.then(success => {
					//console.log("h", success.data)
					//context.commit('setPermissions',success.data);
					context.commit('settings/setSetting', success.data.data, { root: true });

					return success.data;
				})
				.catch(error => {
					console.log(error);

					return error.response;
				});
		}
	},
	fetchPermissions: async (context, payload) => {
		let url = 'profile/permissions';

		return axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(success => {

				context.commit('setPermissions', success.data.data);
			})
			.catch(error => {
				console.log(error);
				return error.response;
			});
	},
	fetchLicense: async (context, payload) => {
		let url = 'profile/license';

		return axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(success => {
				if(success.data && success.data.data && success.data.data.expired){
					context.commit('setLicenseExpired', success.data.data.expired);
					if (router.currentRoute.path !== '/expired') {
						router.push('/expired');
					}
				}
			})
			.catch(error => {
				console.log(error);
				return error.response;
			});
	},
	loginAsToken: async (context, payload) => {
		context.commit('setToken', payload.accessToken);
	},
	/**
	 * Salva i token nuovi restituiti da cambio password / "esci da tutti gli altri dispositivi":
	 * i vecchi sono stati revocati lato backend, questa sessione continua con questi.
	 */
	applySession: (context, session) => {
		if (!session || !session.accessToken) {
			return;
		}
		context.commit('setToken', session.accessToken);
		context.commit('setRefresh', session.refreshToken);
		context.commit('setExpired', session.expired);
		localStorage.setItem('token', session.accessToken);
		localStorage.setItem('refresh', session.refreshToken);
		localStorage.setItem('expired', session.expired);
	},
	logoutAll: async context => {
		let url = 'auth/logout-all';
		let config = {
			headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
			'Content-Type': 'application/json',
		};

		return axios
			.post(`${context.rootGetters['settings/getUrl']}${url}`, {}, config)
			.then(async response => {
				await context.dispatch('applySession', response.data);
				return { success: true };
			})
			.catch(error => {
				return { success: false, message: error.response && error.response.data };
			});
	},
	updateProfile: async (context, payload) => {
		let url = 'auth/update-my-profile';
		let config = {
			headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
			'Content-Type': 'application/json',
		};

		return axios
			.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, config)
			.then(async response => {
				if (response.status === 201) {
					// cambio password: il backend revoca le altre sessioni e rimanda token nuovi per questa
					await context.dispatch('applySession', response.data);
					return response.data;
				} else {
					return { success: false, message: response.data };
				}
			})
			.catch(error => {
				return { success: false, message: error.response.data };
			});
	},
};

const mutations = {
	setName: (state, value) => {
		state.name = value;
	},
	setEmail: (state, value) => {
		state.email = value;
	},
	setId: (state, value) => {
		state.id = value;
	},
	setProfile: (state, value) => {
		state.profile = value;
	},
	setAutenticate: (state, value) => {
		state.autenticate = value;
	},
	setToken: (state, value) => {
		state.token = value;
	},
	setCsrf: (state, value) => {
		state.csrf = value;
	},
	setRefresh: (state, value) => {
		state.refresh = value;
	},
	setExpired: (state, value) => {
		state.expired = value;
	},
	setLanguage: (state, value) => {
		state.language = value;
	},
	setRole: (state, value) => {
		state.role = value;
	},
	setPermissions: (state, value) => {
		state.permissions = value;
	},
	setLicenseExpired: (state, value) => {
		state.licenseExpired = value;
	},
	setModules: (state, value) => {
		state.modules = value;
	},
	setRollback: (state, value) => {
		state.rollback = value;
	},
	setLogout: state => {
		state.autenticate = 0;
		state.name = '';
		state.email = '';
		state.id = '';
		state.profile = '';
		state.token = '';
		state.refresh = '';
		state.role = -1;
		localStorage.clear();
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
